import { updateImageDataByIDForBulkUpload } from "../database/offlineDb/indexDb";

export const persistBulkStatusProjection = async ({
  row,
  publish,
  isCurrent = () => true,
}) => {
  if (!row?.guid || typeof publish !== "function") {
    throw new TypeError("bulk row and publisher are required");
  }
  const updated = await updateImageDataByIDForBulkUpload(row.guid, row);
  if (!isCurrent()) return null;
  if (updated !== 1) throw new Error("bulk row was not durably updated");
  await publish(row);
  return row;
};
